import { BehaviorSubjectToObservable } from '../BehaviorSubjectToObservable';

export const [rxSigner, nextSigner] = BehaviorSubjectToObservable();
